import React from 'react';
import Wave from "react-wavify"
import anchor from "../images/anchor.png"
import './Home.css';
 

function Home() {
    return (
        <div className='home-container'>
            <img src={anchor} alt="Logo" className='logo'></img>
            <h1>AnchorTech Solutions</h1>
            <p>A team of bubbly personalites, passionate about creating H20 solutions that work swimingly!</p>
            <Wave
            className='wave'
            fill="url(#gradient)"
            paused={false}
            style={{ display: 'flex' }}
            options={{
                height:100, 
                amplitude:40, 
                speed:0.2,
                points:4
                }
            }
            >
            <defs>
                <linearGradient id="gradient" gradientTransform="rotate(90)">
                <stop offset="10%"  stopColor="#008cff" />
                <stop offset="90%" stopColor="#004175" />
                </linearGradient>
            </defs>
            </Wave>
        </div>
    );
}

export default Home;
